export enum FILE_TYPE {
  PDF = 'pdf',
  DOC = 'doc',
  DOCX = 'docx',
  JPG = 'jpg',
  BMP = 'bmp',
  DIB = 'dib',
  JPE = 'jpe',
  JFIF = 'jfif',
  GIF = 'gif',
  TIF = 'tif',
  TIFF = 'tiff',
  PNG = 'png',
  HEIC = 'heic',
  RAR = 'rar',
  ZIP = 'zip',
  XLSX = 'xlsx',
  XLS = 'xls',
  JPEG = 'jpeg',
  WEBP = 'webp',
  PPTX = 'pptx',
  PPT = 'ppt',
}

export type TAttachment = {
  file_name: string;
  file_id: string;
  /** Đánh dấu file đã ký số — chỉ dùng phía FE, không gửi lên server. */
  is_signed?: boolean;
};

export type TFetchFileBlobOptions = {
  /** File ký số chỉ serve qua GET /images/{file_id}, không có trong /upload/attachments. */
  fromImages?: boolean;
};